import { render, staticRenderFns } from "./OptinOnboarding.vue?vue&type=template&id=355c2c44&scoped=true"
import script from "./OptinOnboarding.vue?vue&type=script&lang=js"
export * from "./OptinOnboarding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355c2c44",
  null
  
)

export default component.exports